<div class="list-page">
  <form (ngSubmit)="search()" novalidate>
    <div style="max-width: 680px">
      <div class="light-blue-text" style="font-size: 18px; margin-bottom: 20px; line-height: 20px; margin-top: 55px">Hae asiakasta</div>

      <div style="display: flex; flex-flow: row wrap; align-items: center; margin-left: 10px; margin-right: 10px">
        <mat-form-field style="width: 125px; margin-right: 25px">
          <mat-label>Etsi asiakas</mat-label>
          <input #hakuInput type="text" [formField]="lomake.haku" matInput data-lpignore="true" />
          @if (naytaVirhe(lomake.haku, 'required')) {
            <mat-error> Haku puuttuu </mat-error>
          }
          @if (naytaVirhe(lomake.haku, 'minLenght')) {
            <mat-error> Haku on liian lyhyt </mat-error>
          }
        </mat-form-field>
        <mat-form-field style="width: 125px; margin-right: 25px">
          <mat-label>Yhtiömuoto</mat-label>
          <mat-select [formField]="lomake.yhtiomuoto">
            <mat-option [value]="null"> </mat-option>
            @for (yhtiomuoto of yritysmuodot; track yhtiomuoto) {
              <mat-option [value]="yhtiomuoto.koodi">
                {{ yhtiomuoto.nimi }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field style="width: 125px; margin-right: 25px">
          <mat-label>Alv-jakso</mat-label>
          <mat-select [formField]="lomake.alvjakso">
            <mat-option [value]="null"> </mat-option>
            @for (alvjakso of alvjaksot; track alvjakso) {
              <mat-option [value]="alvjakso.koodi">
                {{ alvjakso.nimi }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (isSuperUser()) {
          <mat-form-field style="width: 200px">
            <mat-label>Kirjanpitäjä</mat-label>
            <mat-select [formField]="lomake.kirjanpitaja">
              <mat-option [value]="null"> </mat-option>
              @for (kirjanpitaja of kirjanpitajienNimitiedot(); track kirjanpitaja) {
                <mat-option [value]="kirjanpitaja.avain"> {{ kirjanpitaja.etunimi }} {{ kirjanpitaja.sukunimi }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </div>

      <div style="display: flex; justify-content: space-evenly; margin-top: 1em; margin-bottom: 2em">
        <app-secondary-button actionId="Asiakasta haettiin tiedoilla" [actionContext]="$any(lomake().value())" (click)="search()">
          <div>Hae</div>
        </app-secondary-button>
      </div>
    </div>
  </form>

  @if (tulokset | async; as asiakkaat) {
    <div>
      <div class="light-blue-text" style="font-size: 18px; margin-bottom: 0px; line-height: 20px; margin-top: 55px">Hakutulokset</div>
      @if (asiakkaat.length) {
        <table>
          <tr>
            @if (isDev()) {
              <th>Id</th>
            }
            <th>Nimi</th>
            <th>Y-tunnus</th>
            @if (isSuperUser()) {
              <th>Vastuukirjanpitäjä</th>
            }
            <th>Linkki</th>
          </tr>
          @for (asiakas of asiakkaat; track asiakas) {
            <tr>
              @if (isDev()) {
                <td>{{ asiakas.i }}</td>
              }
              <td>{{ asiakas.n }}</td>
              <td>{{ asiakas.y }}</td>
              @if (isSuperUser()) {
                <td>{{ asiakas.kirjanpitajanNimi }}</td>
              }
              <td><a [routerLink]="'/asiakkaat/' + asiakas.k + '/asiakastiedot'" [href]="'/asiakkaat/' + asiakas.k + '/asiakastiedot'">asiakkaan tiedot</a></td>
            </tr>
          }
        </table>
      } @else {
        <div style="padding: 3em">Antamillasi hakuehdoilla ei löytynyt yhtään asiakasta.</div>
      }
    </div>
  }
</div>
